import { useContext } from "react";

import {
  FileUploaderContext,
  type FileUploaderContextValue,
} from "./FileUploaderContext";

/**
 * Hook to access the FileUploader context
 * @throws Error if used outside of FileUploaderProvider
 */
export function useFileUploaderContext(): FileUploaderContextValue {
  const context = useContext(FileUploaderContext);

  if (!context) {
    throw new Error(
      "useFileUploaderContext must be used within FileUploaderProvider",
    );
  }

  return context;
}
